<template>
  <div>
    <v-dialog
      v-model="isOpen"
      persistent
      scrollable
      fullscreen
      content-class="image-browser print-preview-browser">
      <v-card>
        <v-layout column escalon-absolute-cover>
          <v-flex shrink>
            <print-preview-browser-header
              :hideCloseButton="hideCloseButton"
              @closePrintPreview="closePrintPreview" />
          </v-flex>
          <v-flex shrink>
            <print-preview-browser-toolbar
              :hideCloseButton="hideCloseButton"
              @closePrintPreview="closePrintPreview" />
          </v-flex>
          <v-flex tall-content-wrapper>
            <print-preview-browser-body />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// imports
import { mapGetters, mapActions } from "vuex";
import printPreviewBrowserHeader from "./PrintPreviewBrowserHeader";
import printPreviewBrowserToolbar from "./PrintPreviewBrowserToolbar";
import printPreviewBrowserBody from "./PrintPreviewBrowserBody";

// exports
export default {
  name: "PrintPreviewBrowser",
  props: {
    hideCloseButton: Boolean,
  },
  components: {
    printPreviewBrowserHeader,
    printPreviewBrowserToolbar,
    printPreviewBrowserBody,
  },
  computed: {
    ...mapGetters(["printPreviewContext"]),
    isOpen() {
      return !!this.printPreviewContext;
    },
  },
  methods: {
    ...mapActions(["closePrintPreview"]),
  },
};
</script>